import global from "../config/global";
export function log (tag, msg, forceShow = false) {
  if (forceShow || global.debug) {
    console.log(tag + ' ::: ' + msg)
  }
}
export function loge (tag, msg, forceShow = false) {
  if (forceShow || global.debug) {
    console.error(tag + ' ::: ' + msg)
  }
}



// WEBPACK FOOTER //
// ./src/utils/devext.js